import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

export const requestAggregationGetUser = (userId) =>
    axios.get(`${apiUrl}aggregate/user/${userId}`);

export const otherRequest = () => "";



// WEBPACK FOOTER //
// ./src/actions/aggregation/requests.js